import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=7c0cee2a&scoped=true&"
import script from "./ChatItem.vue?vue&type=script&lang=js&"
export * from "./ChatItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatItem.vue?vue&type=style&index=0&id=7c0cee2a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0cee2a",
  null
  
)

export default component.exports